import { Injectable, inject, signal } from '@angular/core';
import { FinanceApiService } from '../finance/finance-api.service';

@Injectable({ providedIn: 'root' })
export class GrowthPartyLabelService {
  private readonly financeApi = inject(FinanceApiService);
  private readonly labelsSignal = signal<Record<string, string>>({});

  labels(): Record<string, string> {
    return this.labelsSignal();
  }

  label(partyId: string | null | undefined): string {
    const id = partyId?.trim() ?? '';
    if (!id) {
      return '-';
    }
    return this.labelsSignal()[id] ?? id;
  }

  resolve(partyIds: Array<string | null | undefined>): void {
    const known = this.labelsSignal();
    const pending = [...new Set(
      partyIds
        .map(id => id?.trim())
        .filter((id): id is string => !!id && !known[id])
    )];

    for (const partyId of pending) {
      this.financeApi.getPlatformParty(partyId).subscribe({
        next: party => {
          const resolved = party.displayName?.trim() || party.legalName?.trim() || party.id;
          this.labelsSignal.update(current => ({ ...current, [party.id]: resolved }));
        },
        error: () => {
          this.labelsSignal.update(current => ({ ...current, [partyId]: partyId }));
        }
      });
    }
  }
}
